import { PortableText } from "@portabletext/react";

import { Accordion } from "@/components/elements/Accordion";
import { Text } from "@/components/elements/Text";

import { QAListType } from "../types";
import styles from "./styles.module.css";

export const QACombo = ({ question, answer, components }: QAListType) => {
  const isList = components && components.find(({ tag }) => tag === "list");

  return (
    <Accordion title={question}>
      <Text
        as={isList ? "ul" : "div"}
        className={styles.answer}
        size="xs"
        responsive
      >
        <PortableText value={answer} />
      </Text>
    </Accordion>
  );
};
